import asyncForever from 'async/forever';
import Analytics from './analytics';

export default {
  noop,
  log,
  errorLog,
  errorQuietLog,
  debugLog,
  shallowEqual,
  deepEqual,
  deepClone,
  stringHash,
  urlCat,
  between,
  timeFormat,
  doubleToString,
  oneShot,
  topMargin,
  bottomMargin,
  bottomCornerMargin,
  capitalize,
  unPromise,
  repeat,
  filterInPlace,
  preventDefault,
  stopPropagation,
  stopAll,
  lerp,
  lerpList,
  randomBetween,
  randomIntBetween,
  randomArray,
  randomBool,
  randomSign,
  isDebug,
  now,
  needsHlsJS,
};

function noop() {}

function log(...args) {
  console.log(...args);
}

function errorLog(...args) {
  console.error(...args);
  Analytics.log(...args);
}
function errorQuietLog(...args) {
  console.log(...args);
  Analytics.log(...args);
}
function debugLog(...args) {
  console.log(...args);
  Analytics.log(...args);
}

function shallowEqual(objA, objB) {
  if (objA === objB) {
    return true;
  }

  if (
    typeof objA !== 'object' ||
    objA === null ||
    typeof objB !== 'object' ||
    objB === null
  ) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
  for (var i = 0; i < keysA.length; i++) {
    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
}

function deepEqual(x, y) {
  if (x !== y) {
    if (typeof x === 'object' && typeof y === 'object') {
      for (let p in x) {
        if (x.hasOwnProperty(p)) {
          if (!y.hasOwnProperty(p)) {
            return false;
          } else if (!deepEqual(x[p], y[p])) {
            return false;
          }
        }
      }

      for (let p in y) {
        if (y.hasOwnProperty(p) && !x.hasOwnProperty(p)) {
          return false;
        }
      }
    } else {
      return false;
    }
  }
  return true;
}

function deepClone(obj) {
  return JSON.parse(JSON.stringify(obj));
}

function stringHash(s) {
  let hash = 99;
  const len = (s && s.length) || 0;
  for (let i = 0; i < len; i++) {
    const chr = s.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0;
  }
  return hash;
}

function urlCat() {
  let url = '';
  for (let i = 0; i < arguments.length; i++) {
    const part = arguments[0];
    if (url.length > 0 && url.charAt(url.length - 1) !== '/') {
      url += '/';
    }
    if (part.charAt(0) === '/') {
      url += part.slice(1);
    } else {
      url += part;
    }
  }
  return url;
}

function between(value, min, max) {
  return Math.max(Math.min(value, max), min);
}

function timeFormat(time) {
  let seconds = Math.floor(time / 1000);

  let minutes = Math.floor(seconds / 60);
  seconds -= minutes * 60;
  let hours = Math.floor(minutes / 60);
  minutes -= hours * 60;
  return pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
}

function pad(i) {
  return i < 10 ? '0' + i : i;
}

function doubleToString(val) {
  let ret;
  if (val >= 1e42) {
    ret = val.toExponential(2);
  } else if (val >= 1e41) {
    ret = (val / 1e39).toFixed(0) + 'D';
  } else if (val >= 1e40) {
    ret = (val / 1e39).toFixed(1) + 'D';
  } else if (val >= 1e39) {
    ret = (val / 1e39).toFixed(2) + 'D';
  } else if (val >= 1e38) {
    ret = (val / 1e36).toFixed(0) + 'u';
  } else if (val >= 1e37) {
    ret = (val / 1e36).toFixed(1) + 'u';
  } else if (val >= 1e36) {
    ret = (val / 1e36).toFixed(2) + 'u';
  } else if (val >= 1e35) {
    ret = (val / 1e33).toFixed(0) + 'd';
  } else if (val >= 1e34) {
    ret = (val / 1e33).toFixed(1) + 'd';
  } else if (val >= 1e33) {
    ret = (val / 1e33).toFixed(2) + 'd';
  } else if (val >= 1e32) {
    ret = (val / 1e30).toFixed(0) + 'n';
  } else if (val >= 1e31) {
    ret = (val / 1e30).toFixed(1) + 'n';
  } else if (val >= 1e30) {
    ret = (val / 1e30).toFixed(2) + 'n';
  } else if (val >= 1e29) {
    ret = (val / 1e27).toFixed(0) + 'o';
  } else if (val >= 1e28) {
    ret = (val / 1e27).toFixed(1) + 'o';
  } else if (val >= 1e27) {
    ret = (val / 1e27).toFixed(2) + 'o';
  } else if (val >= 1e26) {
    ret = (val / 1e24).toFixed(0) + 'S';
  } else if (val >= 1e25) {
    ret = (val / 1e24).toFixed(1) + 'S';
  } else if (val >= 1e24) {
    ret = (val / 1e24).toFixed(2) + 'S';
  } else if (val >= 1e23) {
    ret = (val / 1e21).toFixed(0) + 's';
  } else if (val >= 1e22) {
    ret = (val / 1e21).toFixed(1) + 's';
  } else if (val >= 1e21) {
    ret = (val / 1e21).toFixed(2) + 's';
  } else if (val >= 1e20) {
    ret = (val / 1e18).toFixed(0) + 'Q';
  } else if (val >= 1e19) {
    ret = (val / 1e18).toFixed(1) + 'Q';
  } else if (val >= 1e18) {
    ret = (val / 1e18).toFixed(2) + 'Q';
  } else if (val >= 1e17) {
    ret = (val / 1e15).toFixed(0) + 'q';
  } else if (val >= 1e16) {
    ret = (val / 1e15).toFixed(1) + 'q';
  } else if (val >= 1e15) {
    ret = (val / 1e15).toFixed(2) + 'q';
  } else if (val >= 1e14) {
    ret = (val / 1e12).toFixed(0) + 't';
  } else if (val >= 1e13) {
    ret = (val / 1e12).toFixed(1) + 't';
  } else if (val >= 1e12) {
    ret = (val / 1e12).toFixed(2) + 't';
  } else if (val >= 1e11) {
    ret = (val / 1e9).toFixed(0) + 'b';
  } else if (val >= 1e10) {
    ret = (val / 1e9).toFixed(1) + 'b';
  } else if (val >= 1e9) {
    ret = (val / 1e9).toFixed(2) + 'b';
  } else if (val >= 1e8) {
    ret = (val / 1e6).toFixed(0) + 'm';
  } else if (val >= 1e7) {
    ret = (val / 1e6).toFixed(1) + 'm';
  } else if (val >= 1e6) {
    ret = (val / 1e6).toFixed(2) + 'm';
  } else if (val >= 1e5) {
    ret = (val / 1e3).toFixed(0) + 'k';
  } else if (val === 0) {
    ret = '0';
  } else if (val) {
    ret = String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  } else {
    ret = '';
  }
  return ret;
}

const g_one_shot_map = {};
function oneShot(key) {
  const ret = !(key in g_one_shot_map);
  if (ret) {
    g_one_shot_map[key] = true;
  }
  return ret;
}

function capitalize(s) {
  return s.charAt(0).toUpperCase() + s.slice(1);
}

let g_is_iphoneX;
function _iphoneX() {
  if (g_is_iphoneX === undefined) {
    const ios =
      /iPad|iPhone|iPod/.test(window.navigator.userAgent) && !window.MSStream;

    const ratio = window.devicePixelRatio || 1;

    const width = window.screen.width * ratio;
    const height = window.screen.height * ratio;

    if (ios && width === 1125 && height === 2436) {
      g_is_iphoneX = true;
    } else {
      g_is_iphoneX = false;
    }
  }
  return g_is_iphoneX;
}

function topMargin() {
  return _iphoneX() ? 44 : 0;
}
function bottomMargin() {
  return _iphoneX() ? 34 : 0;
}
function bottomCornerMargin() {
  return _iphoneX() ? 30 : 0;
}

function unPromise(promise, done) {
  try {
    promise
      .then((...result) => {
        done(null, ...result);
      })
      .catch(err => {
        done(err);
      });
  } catch (e) {
    done(e);
  }
}

function repeat(callback, times, done) {
  if (!done) {
    done = function() {};
  }

  let count = 0;
  const BACKOFF_MS = 1 * 1000;

  asyncForever(
    done => {
      count++;
      if (count > times) {
        done('timeout');
      } else {
        callback(err => {
          if (err) {
            setTimeout(done, BACKOFF_MS);
          } else {
            done('success');
          }
        });
      }
    },
    err => {
      if (err === 'success') {
        err = null;
      }
      done(err);
    }
  );
}

function filterInPlace(array, callback) {
  for (let i = array.length - 1; i >= 0; i--) {
    if (!callback(array[i], i)) {
      array.splice(i, 1);
    }
  }
}

function stopPropagation(e) {
  e && e.stopPropagation && e.stopPropagation();
}
function preventDefault(e) {
  e && e.preventDefault && e.preventDefault();
}
function stopAll(e) {
  stopPropagation(e);
  preventDefault(e);
}

function lerp(x, y, t) {
  return (1 - t) * x + t * y;
}

function lerpList(list, t) {
  const length = list.length;
  const max_index = length - 1;
  const index = between(Math.ceil(t * max_index), 1, max_index) - 1;
  const x = list[index];
  const y = list[index + 1];
  const base_t = index / max_index;
  const new_t = (t - base_t) * max_index;

  return lerp(x, y, new_t);
}

function randomBetween(min, max) {
  return Math.random() * (max - min) + min;
}
function randomIntBetween(min, max) {
  return Math.round(randomBetween(min, max));
}

function randomArray(array) {
  let ret;
  if (array.length > 0) {
    const index = randomIntBetween(0, array.length - 1);
    ret = array[index];
  }
  return ret;
}
function randomBool(odds) {
  if (!odds) {
    odds = 0.5;
  }
  return Math.random() < odds;
}
function randomSign() {
  return Math.random() > 0.5 ? 1 : -1;
}

function isDebug() {
  const is_local = window.location.origin.indexOf(':30') !== -1;

  return is_local;
}
function now() {
  if (window.performance && window.performance.now) {
    return window.performance.now();
  } else {
    return Date.now();
  }
}

function needsHlsJS() {
  const video = document.createElement('video');
  return !video.canPlayType('application/vnd.apple.mpegurl');
}
